export default __webpack_public_path__ + "static/media/flask.2d776ee8.svg";